import * as React from 'react';
import { animationTemp, throttle } from '@/src/utils';
import './index.css';

interface IState {
  hiddenMask: boolean;
}

interface IProps {
  /** 展示modal */
  visible: boolean;
  onClose?: Function;
}

export default class ModalMask extends React.Component<IProps, IState> {
  modalRef: any;
  doing = false; // 动画执行中
  /** 解决首次渲染，值为true无法展开浮层的问题 */
  initVisible = false;

  constructor(props: IProps) {
    super(props);
    this.state = {
      hiddenMask: true,
    };
  }

  /**
     * Modal展示
     */
  handleModalShow = () => {
    const keyFrames = {
      from: { opacity: 0 },
      to: { opacity: 0.8 },
    };
    const animCartPopShow = animationTemp(keyFrames);
    this.modalRef?.setAnimation(animCartPopShow, (callback) => {
      if (callback.state === 'start') {
        this.setState({
          hiddenMask: false
        });
        this.doing = true;
      }
      if (callback.state === 'end') {
        this.doing = false;
      }
    });
  }
  /**
     * Modal消失
     */
  handleModalHidden = () => {
    const { hiddenMask } = this.state;
    if (hiddenMask) {
      return;
    }
    const keyFrames = {
      from: { opacity: 0.8 },
      to: { opacity: 0 },
    };
    const animCartPopShow = animationTemp(keyFrames);
    this.modalRef?.setAnimation(animCartPopShow, (callback) => {
      if (callback.state === 'start') {
        this.doing = true;
      }
      if (callback.state === 'end') {
        this.setState({
          hiddenMask: true
        }, () => {
          this.doing = false;
        });
      }
    });
  }

  /**
     * 点击遮罩层
     */
  handleClose = throttle(() => {
    const { onClose } = this.props;
    // 动画执行过程中不能点击
    if (this.doing) {
      return;
    }

    onClose?.();
    this.handleModalHidden();
  }, 500)

  componentDidUpdate(prevProps): void {
    const { visible } = this.props;
    if (prevProps.visible && !visible) {
      this.handleModalHidden();
    }
    if ((!prevProps.visible || !this.initVisible) && visible) {
      this.initVisible = true;
      this.handleModalShow();
    }
  }

  render() {
    const { hiddenMask } = this.state;
    return (
      <view
        className="modal"
        style={{ display: hiddenMask ? 'none' : 'flex' }}
        ref={(ref: any) => this.modalRef = ref}
        onClick={this.handleClose}
      />
    );
  }
}
